import WebAPI from './WebAPI'

const API_ROOT_NODE = process.env.API_ROOT_NODE

class UserAPI extends WebAPI {
  constructor () {
    super({baseURL: `${API_ROOT_NODE}/DataCity`})
  }

  getMVPDs () {
    return this.__get({extensionURL: '/MVPD'}).then(resp => resp.data)
  }
}

export default new UserAPI()



// WEBPACK FOOTER //
// ./src/app/api/DataCityAPI.js